import React from "react";
import styled from "styled-components";
import ErrorMessage from "./ErrorMessage";

const FloatingLabelInput = styled.div`
    width: 100%;
`;

const FloatingLabelInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    height: 60px;
    border-bottom: 1px solid #CECEDC;
    border-radius: 0px;
    border-color: ${({ focused, error }) =>
        error ? "#cc6666" : focused ? "#5562C0" : "#CECEDC"};
    font-size: inherit;
    padding: 0;
`;

const FloatingLabel = styled.label`
    padding: 0;
    margin: 0;
    border: 0;
    position: absolute;
    color: ${(props) => (props.active ? "#515151" : "#9b9b9b")};
    bottom: calc(50% - 10px);
    left: 20px;
    transition: all 0.2s ease-in-out;
    transform-origin: left top;
    font-size: 18px;
    cursor: text;
    pointer-events: none;
    width: 66.6%;
    transform: ${(props) =>
        props.active ? "translate3d(0, -10px, 0) scale(0.65)" : "none"};
`;

const FloatingInput = styled.input`
    padding: 30px 20px 15px;
    margin: 0;
    border: none;
    outline: none;
    font-size: 20px;
    display: block;
    height: 100%;
    width: 100%;
    border-radius: 3px;
    &::placeholder {
        color: #9b9b9b;
        opacity: ${(props) => (props.active ? 1 : 0)};
        transition: opacity 0.2s cubic-bezier(0.6, 0.04, 0.98, 0.335);
    }
`;

const TextInput = React.forwardRef(
    (
        { value, className, id, label, type, onFocus, onBlur, readonly, errors, ...rest },
        ref
    ) => {
        const [active, setActive] = React.useState(value && value.length > 0);
        const [focused, setFocused] = React.useState(false);
        if(value !== '') {
            // focused = true;
        }
        return (
            <FloatingLabelInput>
                <FloatingLabelInputContainer
                    className={className}
                    focused={focused || value != null}
                    error={errors}
                >
                    <FloatingLabel
                        className={`${className}-label`}
                        htmlFor={id}
                        active={active || value != null}
                    >
                        {label}
                    </FloatingLabel>
                    <FloatingInput
                        active={active || value != null}
                        className={`${className}-input`}
                        id={id}
                        name={id}
                        onBlur={(e) => {
                            setActive(e.target.value.length !== 0);
                            setFocused(false);
                            typeof onBlur === "function" && onBlur();
                        }}
                        onFocus={() => {
                            setActive(true);
                            setFocused(true);
                            typeof onFocus === "function" && onFocus();
                        }}
                        type={type}
                        ref={ref}
                        value={value}
                        readonly={readonly}
                        {...rest}
                    />
                </FloatingLabelInputContainer>
                {errors && <ErrorMessage>{errors.message}</ErrorMessage>}
            </FloatingLabelInput>
        );
    }
);

export default TextInput;
